/* eslint-disable sort-keys-fix/sort-keys-fix, typescript-sort-keys/interface, camelcase */

/*
 * This code is generated by ../../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 *
 * Source: ../../types/drag-and-drop-exercise/v2.ts
 */
import { createValidator } from '../../helpers/validator';
export var DragAndDropExerciseV2Schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    title: {
      type: 'string'
    },
    xp: {
      type: 'number'
    },
    course_id: {
      type: 'number'
    },
    chapter_id: {
      type: 'number'
    },
    assignment: {
      type: 'string'
    },
    hint: {
      type: 'string'
    },
    instructions: {
      type: ['string', 'null'],
      default: null
    },
    question: {
      anyOf: [{
        type: 'object',
        properties: {
          flavor: {
            type: 'string',
            enum: ['Order'],
            default: 'Order'
          },
          solution: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                id: {
                  type: 'string',
                  description: 'Unique name to refer to the drop zone in the correctness conditions.'
                },
                title: {
                  type: 'string',
                  description: 'Title of the drop zone.'
                },
                draggableItems: {
                  type: 'array',
                  items: {
                    type: 'object',
                    properties: {
                      content: {
                        type: 'string',
                        description: 'Content of the item.'
                      },
                      id: {
                        type: 'string',
                        description: 'Unique name to refer to the item in the correctness conditions.'
                      },
                      language: {
                        type: 'string',
                        description: 'Used to provide language highlighting for the user on the specific item.'
                      }
                    },
                    required: ['content', 'id']
                  },
                  description: 'List of items for the drop zone.'
                }
              },
              required: ['id', 'title']
            },
            minItems: 1,
            maxItems: 1
          },
          correctnessConditions: {
            type: 'object',
            properties: {
              successMessage: {
                type: 'string',
                default: 'Well done!',
                description: 'Feedback message when the submission is correct.'
              },
              failureMessage: {
                type: 'string',
                description: 'Feedback message when the submission is wrong and there is no matching condition.'
              },
              isOrdered: {
                type: 'boolean',
                default: false,
                description: 'Is the order of the items important?'
              },
              checks: {
                type: 'array',
                items: {
                  type: 'object',
                  properties: {
                    condition: {
                      type: 'string',
                      description: 'Condition to show this feedback message.'
                    },
                    shouldBe: {
                      type: 'boolean',
                      default: false,
                      description: 'Defines to what the condition should evaluate when the user gives a correct solution'
                    },
                    message: {
                      type: 'string',
                      description: 'The message that should be shown when the check has not passed'
                    }
                  },
                  required: ['condition', 'shouldBe', 'message']
                },
                description: 'List of checks that determines the feedback on submissions.'
              }
            },
            required: ['successMessage', 'isOrdered', 'checks'],
            description: 'Configuration that determines the feedback on submissions.'
          }
        },
        required: ['correctnessConditions', 'flavor', 'solution'],
        title: 'Order'
      }, {
        type: 'object',
        properties: {
          flavor: {
            type: 'string',
            enum: ['Parsons'],
            default: 'Parsons'
          },
          solution: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                id: {
                  type: 'string',
                  description: 'Unique name to refer to the drop zone in the correctness conditions.'
                },
                title: {
                  type: 'string',
                  description: 'Title of the drop zone.'
                },
                draggableItems: {
                  type: 'array',
                  items: {
                    type: 'object',
                    properties: {
                      content: {
                        type: 'string',
                        description: 'Content of the item.'
                      },
                      id: {
                        type: 'string',
                        description: 'Unique name to refer to the item in the correctness conditions.'
                      },
                      language: {
                        type: 'string',
                        description: 'Used to provide language highlighting for the user on the specific item.'
                      },
                      offset: {
                        type: 'number',
                        description: 'The indentation level of the item.'
                      }
                    },
                    required: ['content', 'id']
                  },
                  description: 'List of items for the drop zone.'
                },
                language: {
                  type: 'string',
                  description: 'Used to provide language highlighting for the user in a Parsons exercise'
                },
                maxOffset: {
                  type: 'number',
                  description: 'The maximum amount of indentation levels that may be used for a parsons exercise'
                }
              },
              required: ['id', 'title']
            },
            minItems: 1,
            maxItems: 1
          },
          correctnessConditions: {
            type: 'object',
            properties: {
              successMessage: {
                type: 'string',
                default: 'Well done!',
                description: 'Feedback message when the submission is correct.'
              },
              failureMessage: {
                type: 'string',
                description: 'Feedback message when the submission is wrong and there is no matching condition.'
              },
              isOrdered: {
                type: 'boolean',
                default: false,
                description: 'Is the order of the items important?'
              },
              checks: {
                type: 'array',
                items: {
                  type: 'object',
                  properties: {
                    condition: {
                      type: 'string',
                      description: 'Condition to show this feedback message.'
                    },
                    shouldBe: {
                      type: 'boolean',
                      default: false,
                      description: 'Defines to what the condition should evaluate when the user gives a correct solution'
                    },
                    message: {
                      type: 'string',
                      description: 'The message that should be shown when the check has not passed'
                    }
                  },
                  required: ['condition', 'shouldBe', 'message']
                },
                description: 'List of checks that determines the feedback on submissions.'
              }
            },
            required: ['successMessage', 'isOrdered', 'checks'],
            description: 'Configuration that determines the feedback on submissions.'
          }
        },
        required: ['correctnessConditions', 'flavor', 'solution'],
        title: 'Parsons'
      }, {
        type: 'object',
        properties: {
          flavor: {
            type: 'string',
            enum: ['Classify'],
            default: 'Classify'
          },
          solution: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                id: {
                  type: 'string',
                  description: 'Unique name to refer to the drop zone in the correctness conditions.'
                },
                title: {
                  type: 'string',
                  description: 'Title of the drop zone.'
                },
                draggableItems: {
                  type: 'array',
                  items: {
                    type: 'object',
                    properties: {
                      content: {
                        type: 'string',
                        description: 'Content of the item.'
                      },
                      id: {
                        type: 'string',
                        description: 'Unique name to refer to the item in the correctness conditions.'
                      },
                      language: {
                        type: 'string',
                        description: 'Used to provide language highlighting for the user on the specific item.'
                      }
                    },
                    required: ['content', 'id']
                  },
                  description: 'List of items for the drop zone.'
                }
              },
              required: ['id', 'title']
            },
            minItems: 3,
            maxItems: 5
          },
          correctnessConditions: {
            type: 'object',
            properties: {
              successMessage: {
                type: 'string',
                default: 'Well done!',
                description: 'Feedback message when the submission is correct.'
              },
              failureMessage: {
                type: 'string',
                description: 'Feedback message when the submission is wrong and there is no matching condition.'
              },
              isOrdered: {
                type: 'boolean',
                default: false,
                description: 'Is the order of the items important?'
              },
              checks: {
                type: 'array',
                items: {
                  type: 'object',
                  properties: {
                    condition: {
                      type: 'string',
                      description: 'Condition to show this feedback message.'
                    },
                    shouldBe: {
                      type: 'boolean',
                      default: false,
                      description: 'Defines to what the condition should evaluate when the user gives a correct solution'
                    },
                    message: {
                      type: 'string',
                      description: 'The message that should be shown when the check has not passed'
                    }
                  },
                  required: ['condition', 'shouldBe', 'message']
                },
                description: 'List of checks that determines the feedback on submissions.'
              }
            },
            required: ['successMessage', 'isOrdered', 'checks'],
            description: 'Configuration that determines the feedback on submissions.'
          }
        },
        required: ['correctnessConditions', 'flavor', 'solution'],
        title: 'Classify'
      }]
    }
  },
  required: ['assignment', 'chapter_id', 'course_id', 'hint', 'instructions', 'question', 'title', 'xp'],
  definitions: {}
};
export var isValidDragAndDropExerciseV2 = createValidator(DragAndDropExerciseV2Schema);
export var DragAndDropExerciseV2Definition = {
  schema: DragAndDropExerciseV2Schema,
  validate: isValidDragAndDropExerciseV2
};